import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { LicenseInfo } from '@mui/x-license';
import App from './App';
import { AppThemeProvider } from './context/ThemeContext';

if (process.env.REACT_APP_MUI_LICENSE_KEY) {
    LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppThemeProvider>
    <Router>
      <App />
    </Router>
  </AppThemeProvider>
);
